import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Formik } from "formik";
import {
  Autocomplete,
  createTheme,
  Divider,
  FormHelperText,
  IconButton,
  TextField,
  ThemeProvider,
  Typography,
  useTheme,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
} from "@mui/material";
import * as Yup from "yup";
import { useState } from "react";
import {
  useGetPackagesQuery,
  useLazyGetPackagesQuery,
} from "store/slices/apis/packageSlice";
import { useGetContractorQuery } from "store/slices/apis/contractors";
import { IoMdClose } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import DragAndDropUpload from "components/FileUploader/DragAndDropUpload";
import { FaRegFileLines } from "react-icons/fa6";
import { RxCross2 } from "react-icons/rx";
import { useGetProjectDetailQuery } from "store/slices/apis/projectApiSlice";
import { useAddKeyClaimsMutation } from "store/slices/apis/keyClaimsSlice";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useGetAllWorkflowQuery } from "store/slices/apis/workflowSlice";
import { ReactComponent as CrossIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"
import { ReactComponent as CalendarIcon } from "assets/PwC_Funct_Icons_Calendar_Outline_Black_RGB.svg"

const Statuses = [
  { label: "Client Rejected", value: "Client Rejected" },
  { label: "Submitted", value: "Submitted" },
  { label: "Rejected", value: "Rejected" },
  { label: "Approved", value: "Approved" },
  { label: "Identified", value: "Identified" },
];

export default function AddClaims(props) {
  const { open, cancelIssue, openNotification, refetch } = props;
  const newtheme = useTheme();
  const { projectId } = useParams();
  const navigate = useNavigate();
  const { data: packages } = useGetPackagesQuery({ projectId: projectId });
  const { data: contractors } = useGetContractorQuery();
  const [getSubPackage1, { data: subPackageList1 }] = useLazyGetPackagesQuery();
  const [files, setFiles] = useState([]);
  const { data: projectDetail } = useGetProjectDetailQuery(projectId);
  const workflowList = useGetAllWorkflowQuery({ projectId, pageNumber: 1, pageSize: 100, entityName: 'Claims' })
  const [
    addKeyClaims,
    { data: addKeyIssueRes, isLoading, isSuccess, isError, error },
  ] = useAddKeyClaimsMutation();

  const [formData, setFormData] = useState({
    package: "",
    subPackage1: "",
    contract_number: "",
    consultant_contractor: "",
    claim_raised_to: "",
    claim_received_on: "",
    claim_raised_by_refrence: "",
    claim_raised_by_date_received: "",
    reason_for_claim: "",
    claim_raised_to_reference: "",
    claim_raised_to_date_of_response: "",
    claim_raised_to_position: "",
    claim_raised_by_estimate_cost_impact: "",
    claim_raised_to_estimate_cost_impact: "",
    approved_cost_impact: "",
    claim_raised_by_estimate_time_impact: "",
    claim_raised_to_estimate_time_impact: "",
    approved_time_impact: "",
    actual_date_of_closure: "",
    description_of_claim: "",
    status: "",
    WorkflowApprovalId: ""
  });

  const theme = createTheme({
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            border: "2px solid #e6e6e6",
            "& .MuiFilledInput-input": {
              backgroundColor: "#fff",
              color: "#252525",
              fontSize: "16px",
            },
            "& .MuiFilledInput-root::before": {
              borderBottom: "none",
            },
            "& .MuiFilledInput-root::after": {
              borderBottom: `2px solid ${newtheme?.customSettings?.themeColor}`,
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#696969",
              fontSize: "14px",
            },
            "& .MuiFormLabel-root": {
              fontSize: "15px",
            },
            "& .MuiFilledInput-root.Mui-disabled:before": {
              borderBottom: "none",
            },
            "& .MuiFilledInput-root": {
              backgroundColor: "#fff",
            },
            "& .MuiFilledInput-input": {
              backgroundColor: "none",
              fontSize: "14px",
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#696969",
            },
            "& .MuiFilledInput-root.Mui-disabled": {
              backgroundColor: "#fff",
              color: "inherit",
            },
            "& .MuiFilledInput-input.Mui-disabled": {
              WebkitTextFillColor: "#696969",
              opacity: "none",
            },
          },
        },
      },
    },
  });

  const handleClose = () => { };

  const validationSchema = Yup.object({
    package: Yup.string().required("Category is required"),
    subPackage1: Yup.string().required("Sub Category is required"),
    contract_number: Yup.string().required("Contract Number is required"),
    // consultant_contractor: Yup.string().required(
    //   "Consultant Contractor is required"
    // ),
    claim_raised_to: Yup.string().required("Claim Raised To is required"),
    claim_received_on: Yup.date()
      .required("Claim Received On is required")
      .nullable()
      .typeError("Claim Received On must be a valid date"),
    claim_raised_by_refrence: Yup.string().required(
      "Claim Raised By Reference is required"
    ),
    claim_raised_by_date_received: Yup.date()
      .required("Claim Raised By Date Received is required")
      .nullable()
      .typeError("Claim Raised By Date Received must be a valid date"),
    reason_for_claim: Yup.string().required("Reason For Claim is required"),
    claim_raised_to_reference: Yup.string().required(
      "Claim Raised to Reference for Claim is required"
    ),
    claim_raised_to_date_of_response: Yup.date()
      .required("Claim Raised To Date Of Response is required")
      .nullable()
      .typeError("Claim Raised To Date Of Response must be a valid date"),
    claim_raised_to_position: Yup.string().required(
      "Claim Raised To Position is required"
    ),
    claim_raised_by_estimate_cost_impact: Yup.string().required(
      "Claim Raised By Estimate Cost Impact is required"
    ),
    claim_raised_to_estimate_cost_impact: Yup.string().required(
      "Claim Raised To Estimate Cost Impact is required"
    ),
    approved_cost_impact: Yup.string().required(
      "Approved Cost Impact is required"
    ),
    claim_raised_by_estimate_time_impact: Yup.string().required(
      "Claim Raised By Estimate Time Impact is required"
    ),
    claim_raised_to_estimate_time_impact: Yup.string().required(
      "Claim Raised To Estimate Time Impact is required"
    ),
    approved_time_impact: Yup.string().required(
      "Approved Time Impact is required"
    ),
    actual_date_of_closure: Yup.date()
      .required("Actual Date of Closure is required")
      .nullable()
      .typeError("Actual Date of Closure must be a valid date"),
    description_of_claim: Yup.string().required(
      "Description of Claim is required"
    ),
    status: Yup.string().required("Status is required"),
    WorkflowApprovalId: Yup.string().required("Workflow field is required"),
  });

  const handleDrop = (acceptedFiles, rejectedFiles) => {
    if (rejectedFiles.length > 0) {
      openNotification("File type must be image/*");
      return;
    }
    const newFiles = acceptedFiles.filter(
      (file) => !files.some((f) => f.name === file.name)
    );

    if (newFiles.length > 0) {
      setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    }
  };

  const handleRemoveFile = (fileName) => {
    setFiles(files.filter((file) => file.name !== fileName));
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    let reqBody = {
      package: values.package,
      sub_package: values.subPackage1,
      contract_number: values.contract_number,
      consultant_contractor: values.consultant_contractor,
      claim_raised_to: values.claim_raised_to,
      claim_received_on:
        values?.claim_received_on && dayjs(values.claim_received_on).isValid()
          ? dayjs(values.claim_received_on).format("YYYY-MM-DD") +
          "T00:00:00.000Z"
          : null,
      claim_raised_by_refrence: values.claim_raised_by_refrence,
      claim_raised_by_date_received:
        values?.claim_raised_by_date_received &&
          dayjs(values.claim_raised_by_date_received).isValid()
          ? dayjs(values.claim_raised_by_date_received).format("YYYY-MM-DD") +
          "T00:00:00.000Z"
          : null,
      reason_for_claim: values.reason_for_claim,
      claim_raised_to_reference: values.claim_raised_to_reference,
      claim_raised_to_date_of_response:
        values?.claim_raised_to_date_of_response &&
          dayjs(values.claim_raised_to_date_of_response).isValid()
          ? dayjs(values.claim_raised_to_date_of_response).format(
            "YYYY-MM-DD"
          ) + "T00:00:00.000Z"
          : null,
      claim_raised_to_position: values.claim_raised_to_position,
      claim_raised_by_estimate_cost_impact:
        values.claim_raised_by_estimate_cost_impact,
      claim_raised_to_estimate_cost_impact:
        values.claim_raised_to_estimate_cost_impact,
      approved_cost_impact: values?.approved_cost_impact,
      claim_raised_by_estimate_time_impact:
        values.claim_raised_by_estimate_time_impact,
      claim_raised_to_estimate_time_impact:
        values.claim_raised_to_estimate_time_impact,
      approved_time_impact: values.approved_time_impact,
      actual_date_of_closure:
        values?.actual_date_of_closure &&
          dayjs(values.actual_date_of_closure).isValid()
          ? dayjs(values.actual_date_of_closure).format("YYYY-MM-DD") +
          "T00:00:00.000Z"
          : null,
      description_of_claim: values.description_of_claim,
      status: values.status,
      ProjectId: projectId,
      // project: projectDetail?.data?.project_name,
      WorkflowApprovalId: values.WorkflowApprovalId
    };

    try {
      const formData = new FormData();
      formData.append("claimJson", JSON.stringify(reqBody));
      formData.append("file", files);
      const response = await addKeyClaims(formData).unwrap();
      if (response?.status == "Success") {
        openNotification(
          response?.message || "Claim Tracker created successfully",
          "success"
        );
        resetForm();
        refetch();
        cancelIssue();
        navigate(`/projects/${projectId}/key-claims/claims-submitted-by-me`);
      } else {
        openNotification("Error in change tracker creation");
      }
    } catch (error) {
      openNotification(error?.error, "error");
    } finally {
      setSubmitting(false);
    }
  };

  const CustomCalendarIcon = (props) => (
    <CalendarIcon {...props} style={{ width: 26, height: 26, fill: "#696969 ", stroke: "#696969", strokeWidth: 4 }} />
  );

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiDialog-paper": {
            overflowY: "inherit",
          },
        }}
      >
        <DialogTitle sx={{ fontSize: "20px", color: "#696969" }}>
          Add New Claim
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={cancelIssue}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
          <CrossIcon style={{ fontSize: "20px", width: "20px", height: "20px", fill: "#808080" }} />
        </IconButton>
        <Divider sx={{ w: 1 }} />
        <DialogContent>
          <ThemeProvider theme={theme}>
            <Box sx={{ mt: 1 }}>
              <Formik
                initialValues={formData}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                  setTouched,
                }) => {
                  return (
                    <form onSubmit={handleSubmit}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Typography
                            variant="h4"
                            gutterBottom
                            sx={{ fontSize: "20px", color: "#252525" }}
                          >
                            Select Categories
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Autocomplete
                            options={(packages?.data || [])?.filter(
                              (option) => option
                            )}
                            getOptionLabel={(option) => option}
                            value={
                              packages?.data?.find(
                                (option) => option === values?.package
                              ) || null
                            }
                            onChange={(_, newValue) => {
                              setFieldValue(
                                "package",
                                newValue ? newValue : ""
                              );
                              setFieldValue("subPackage1", "");
                              getSubPackage1({
                                projectId: projectId,
                                type: "subPackage1",
                              });
                            }}
                            onBlur={() =>
                              setTouched({ ...touched, package: true })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Category"
                                name="package"
                                slotProps={{ inputLabel: { shrink: true } }}
                                variant="filled"
                              />
                            )}
                            ListboxProps={{
                              sx: { fontSize: "13px" },
                            }}
                          />
                          {touched?.package && errors?.package && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.package}`}</FormHelperText>
                          )}
                        </Grid>

                        {values?.package && (
                          <Grid item xs={12} sm={6}>
                            <Autocomplete
                              // options={subPackageList1?.data}
                              options={(subPackageList1?.data || [])?.filter(
                                (option) => option
                              )}
                              getOptionLabel={(option) => option}
                              value={
                                subPackageList1?.data?.find(
                                  (option) =>
                                    option === values?.subPackage1
                                ) || null
                              }
                              onChange={(_, newValue) => {
                                setFieldValue(
                                  "subPackage1",
                                  newValue ? newValue : ""
                                );
                              }}
                              onBlur={() =>
                                setTouched({ ...touched, subPackage1: true })
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Sub Category 1"
                                  name="subPackage1"
                                  slotProps={{ inputLabel: { shrink: true } }}
                                  variant="filled"
                                />
                              )}
                              ListboxProps={{
                                sx: { fontSize: "13px" },
                              }}
                            />
                            {touched?.subPackage1 && errors?.subPackage1 && (
                              <FormHelperText
                                sx={{ color: "#C52A1A", fontSize: "12px" }}
                              >{`${errors?.subPackage1}`}</FormHelperText>
                            )}
                          </Grid>
                        )}
                      </Grid>

                      <Divider
                        sx={{
                          width: "100%",
                          mb: 2,
                          mt: 2,
                          borderBottomWidth: "medium",
                        }}
                      />

                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Typography
                            variant="h4"
                            gutterBottom
                            sx={{ fontSize: "20px", color: "#252525" }}
                          >
                            Enter Claim Details
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Autocomplete
                            options={workflowList?.data?.data || []}
                            getOptionLabel={(option) => option?.workflowName}
                            value={workflowList?.data?.data?.find((option) => option?.id === values?.WorkflowApprovalId) || null}
                            onChange={(_, newValue) => setFieldValue("WorkflowApprovalId", newValue ? newValue?.id : "")}
                            onBlur={() => setTouched({ ...touched, WorkflowApprovalId: true })}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Workflow"
                                placeholder='Select Workflow'
                                name="WorkflowApprovalId"
                                // slotProps={{ inputLabel: { shrink: true } }}
                                variant="filled"
                              />
                            )}
                            ListboxProps={{
                              sx: { fontSize: "13px" },
                            }}
                          />
                          {touched?.WorkflowApprovalId && errors?.WorkflowApprovalId &&
                            <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.WorkflowApprovalId}`}</FormHelperText>
                          }
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Contract Number"
                            name="contract_number"
                            fullWidth
                            value={values?.contract_number}
                            onChange={handleChange}
                            onBlur={() =>
                              setTouched({ ...touched, contract_number: true })
                            }
                            variant="filled"
                          />
                          {touched?.contract_number &&
                            errors?.contract_number && (
                              <FormHelperText
                                sx={{ color: "#C52A1A", fontSize: "12px" }}
                              >{`${errors?.contract_number}`}</FormHelperText>
                            )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Autocomplete
                            options={contractors?.data}
                            getOptionLabel={(option) => option.name}
                            value={
                              contractors?.data.find(
                                (option) => option.name === values.consultant_contractor
                              ) || null
                            }
                            onChange={(_, newValue) =>
                              setFieldValue(
                                "consultant_contractor",
                                newValue ? newValue.name : ""
                              )
                            }
                            onBlur={() =>
                              setTouched({ ...touched, consultant_contractor: true })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Consultant/Contractor"
                                name="consultant_contractor"
                                // error={touched.contractor && Boolean(errors.contractor)}
                                // helperText={touched.contractor && errors.contractor}
                                // slotProps={{ inputLabel: { shrink: true } }}
                                variant="filled"
                              />
                            )}
                            ListboxProps={{
                              sx: { fontSize: "13px" },
                            }}
                          />
                          {touched?.consultant_contractor && errors?.consultant_contractor && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.consultant_contractor}`}</FormHelperText>
                          )}
                        </Grid>
                        {/* <Grid item xs={12} sm={6}>
                          <TextField
                            label="Consultant Contractor"
                            name="consultant_contractor"
                            fullWidth
                            value={values?.consultant_contractor}
                            onChange={handleChange}
                            onBlur={() =>
                              setTouched({
                                ...touched,
                                consultant_contractor: true,
                              })
                            }
                            variant="filled"
                          />
                          {touched?.consultant_contractor &&
                            errors?.consultant_contractor && (
                              <FormHelperText
                                sx={{ color: "#C52A1A", fontSize: "12px" }}
                              >{`${errors?.consultant_contractor}`}</FormHelperText>
                            )}
                        </Grid> */}

                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Claim Raised To"
                            name="claim_raised_to"
                            fullWidth
                            value={values?.claim_raised_to}
                            onChange={handleChange}
                            onBlur={() =>
                              setTouched({ ...touched, claim_raised_to: true })
                            }
                            variant="filled"
                          />
                          {touched?.claim_raised_to &&
                            errors?.claim_raised_to && (
                              <FormHelperText
                                sx={{ color: "#C52A1A", fontSize: "12px" }}
                              >{`${errors?.claim_raised_to}`}</FormHelperText>
                            )}
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              label="Claim received on"
                              value={
                                values?.claim_received_on
                                  ? dayjs(values.claim_received_on)
                                  : null
                              }
                              format="DD-MM-YYYY"
                              onChange={(newValue) => {
                                handleChange({
                                  target: {
                                    name: "claim_received_on",
                                    value: newValue ? newValue : "",
                                  },
                                });
                              }}
                              slots={{
                                openPickerIcon: CustomCalendarIcon,
                              }}
                              onBlur={() =>
                                setTouched({
                                  ...touched,
                                  claim_received_on: true,
                                })
                              }
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  variant: "filled",
                                  InputLabelProps: {
                                    style: { fontSize: 16, fontWeight: 400 },
                                  },
                                  inputProps: {
                                    style: { height: "20px" },
                                  },
                                  placeholder: "dd/mm/yyyy",
                                  sx: {
                                    input: {
                                      "&::placeholder": {
                                        fontSize: 16,
                                        fontWeight: 400,
                                      },
                                    },
                                    "& .MuiFormLabel-asterisk": {
                                      color: "red",
                                      fontSize: 20,
                                    },
                                  },
                                  onKeyDown: (e) => e.preventDefault(),
                                },
                              }}
                            />
                            {touched?.claim_received_on &&
                              errors?.claim_received_on && (
                                <FormHelperText
                                  sx={{ color: "#C52A1A", fontSize: "12px" }}
                                >{`${errors?.claim_received_on}`}</FormHelperText>
                              )}
                          </LocalizationProvider>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Claim Raised by Refrence"
                            name="claim_raised_by_refrence"
                            fullWidth
                            value={values?.claim_raised_by_refrence}
                            onChange={handleChange}
                            onBlur={() =>
                              setTouched({
                                ...touched,
                                claim_raised_by_refrence: true,
                              })
                            }
                            variant="filled"
                          />
                          {touched?.claim_raised_by_refrence &&
                            errors?.claim_raised_by_refrence && (
                              <FormHelperText
                                sx={{ color: "#C52A1A", fontSize: "12px" }}
                              >{`${errors?.claim_raised_by_refrence}`}</FormHelperText>
                            )}
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              label="Claim Raised by Date Received"
                              value={
                                values?.claim_raised_by_date_received
                                  ? dayjs(values.claim_raised_by_date_received)
                                  : null
                              }
                              format="DD-MM-YYYY"
                              onChange={(newValue) => {
                                handleChange({
                                  target: {
                                    name: "claim_raised_by_date_received",
                                    value: newValue ? newValue : "",
                                  },
                                });
                              }}
                              slots={{
                                openPickerIcon: CustomCalendarIcon,
                              }}
                              onBlur={() =>
                                setTouched({
                                  ...touched,
                                  claim_raised_by_date_received: true,
                                })
                              }
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  variant: "filled",
                                  InputLabelProps: {
                                    style: { fontSize: 16, fontWeight: 400 },
                                  },
                                  inputProps: {
                                    style: { height: "20px" },
                                  },
                                  placeholder: "dd/mm/yyyy",
                                  sx: {
                                    input: {
                                      "&::placeholder": {
                                        fontSize: 16,
                                        fontWeight: 400,
                                      },
                                    },
                                    "& .MuiFormLabel-asterisk": {
                                      color: "red",
                                      fontSize: 20,
                                    },
                                  },
                                  onKeyDown: (e) => e.preventDefault(),
                                },
                              }}
                            />
                            {touched?.claim_raised_by_date_received &&
                              errors?.claim_raised_by_date_received && (
                                <FormHelperText
                                  sx={{ color: "#C52A1A", fontSize: "12px" }}
                                >{`${errors?.claim_raised_by_date_received}`}</FormHelperText>
                              )}
                          </LocalizationProvider>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Reason for Claim"
                            name="reason_for_claim"
                            fullWidth
                            value={values?.reason_for_claim}
                            onChange={handleChange}
                            onBlur={() =>
                              setTouched({ ...touched, reason_for_claim: true })
                            }
                            variant="filled"
                          />
                          {touched?.reason_for_claim &&
                            errors?.reason_for_claim && (
                              <FormHelperText
                                sx={{ color: "#C52A1A", fontSize: "12px" }}
                              >{`${errors?.reason_for_claim}`}</FormHelperText>
                            )}
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Claim Raised to Reference"
                            name="claim_raised_to_reference"
                            fullWidth
                            value={values?.claim_raised_to_reference}
                            onChange={handleChange}
                            onBlur={() =>
                              setTouched({
                                ...touched,
                                claim_raised_to_reference: true,
                              })
                            }
                            variant="filled"
                          />
                          {touched?.claim_raised_to_reference &&
                            errors?.claim_raised_to_reference && (
                              <FormHelperText
                                sx={{ color: "#C52A1A", fontSize: "12px" }}
                              >{`${errors?.claim_raised_to_reference}`}</FormHelperText>
                            )}
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              label="Claim Raised to Date of Response"
                              value={
                                values?.claim_raised_to_date_of_response
                                  ? dayjs(
                                    values.claim_raised_to_date_of_response
                                  )
                                  : null
                              }
                              format="DD-MM-YYYY"
                              onChange={(newValue) => {
                                handleChange({
                                  target: {
                                    name: "claim_raised_to_date_of_response",
                                    value: newValue ? newValue : "",
                                  },
                                });
                              }}
                              slots={{
                                openPickerIcon: CustomCalendarIcon,
                              }}
                              onBlur={() =>
                                setTouched({
                                  ...touched,
                                  claim_raised_to_date_of_response: true,
                                })
                              }
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  variant: "filled",
                                  InputLabelProps: {
                                    style: { fontSize: 16, fontWeight: 400 },
                                  },
                                  inputProps: {
                                    style: { height: "20px" },
                                  },
                                  placeholder: "dd/mm/yyyy",
                                  sx: {
                                    input: {
                                      "&::placeholder": {
                                        fontSize: 16,
                                        fontWeight: 400,
                                      },
                                    },
                                    "& .MuiFormLabel-asterisk": {
                                      color: "red",
                                      fontSize: 20,
                                    },
                                  },
                                  onKeyDown: (e) => e.preventDefault(),
                                },
                              }}
                            />
                            {touched?.claim_raised_to_date_of_response &&
                              errors?.claim_raised_to_date_of_response && (
                                <FormHelperText
                                  sx={{ color: "#C52A1A", fontSize: "12px" }}
                                >{`${errors?.claim_raised_to_date_of_response}`}</FormHelperText>
                              )}
                          </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Claim Raised to Position"
                            name="claim_raised_to_position"
                            fullWidth
                            value={values?.claim_raised_to_position}
                            onChange={handleChange}
                            onBlur={() =>
                              setTouched({
                                ...touched,
                                claim_raised_to_position: true,
                              })
                            }
                            variant="filled"
                          />
                          {touched?.claim_raised_to_position &&
                            errors?.claim_raised_to_position && (
                              <FormHelperText
                                sx={{ color: "#C52A1A", fontSize: "12px" }}
                              >{`${errors?.claim_raised_to_position}`}</FormHelperText>
                            )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Claim Raised by Estimate Cost Impact"
                            name="claim_raised_by_estimate_cost_impact"
                            fullWidth
                            value={values?.claim_raised_by_estimate_cost_impact}
                            onChange={handleChange}
                            onBlur={() =>
                              setTouched({
                                ...touched,
                                claim_raised_by_estimate_cost_impact: true,
                              })
                            }
                            variant="filled"
                          />
                          {touched?.claim_raised_by_estimate_cost_impact &&
                            errors?.claim_raised_by_estimate_cost_impact && (
                              <FormHelperText
                                sx={{ color: "#C52A1A", fontSize: "12px" }}
                              >{`${errors?.claim_raised_by_estimate_cost_impact}`}</FormHelperText>
                            )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Claim Raised to Estimate Cost Impact"
                            name="claim_raised_to_estimate_cost_impact"
                            fullWidth
                            value={values?.claim_raised_to_estimate_cost_impact}
                            onChange={handleChange}
                            onBlur={() =>
                              setTouched({
                                ...touched,
                                claim_raised_to_estimate_cost_impact: true,
                              })
                            }
                            variant="filled"
                          />
                          {touched?.claim_raised_to_estimate_cost_impact &&
                            errors?.claim_raised_to_estimate_cost_impact && (
                              <FormHelperText
                                sx={{ color: "#C52A1A", fontSize: "12px" }}
                              >{`${errors?.claim_raised_to_estimate_cost_impact}`}</FormHelperText>
                            )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Approved Cost Impact"
                            name="approved_cost_impact"
                            fullWidth
                            value={values?.approved_cost_impact}
                            onChange={handleChange}
                            onBlur={() =>
                              setTouched({
                                ...touched,
                                approved_cost_impact: true,
                              })
                            }
                            variant="filled"
                          />
                          {touched?.approved_cost_impact &&
                            errors?.approved_cost_impact && (
                              <FormHelperText
                                sx={{ color: "#C52A1A", fontSize: "12px" }}
                              >{`${errors?.approved_cost_impact}`}</FormHelperText>
                            )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Claim Raised by Estimate Time Impact"
                            name="claim_raised_by_estimate_time_impact"
                            fullWidth
                            value={values?.claim_raised_by_estimate_time_impact}
                            onChange={handleChange}
                            onBlur={() =>
                              setTouched({
                                ...touched,
                                claim_raised_by_estimate_time_impact: true,
                              })
                            }
                            variant="filled"
                          />
                          {touched?.claim_raised_by_estimate_time_impact &&
                            errors?.claim_raised_by_estimate_time_impact && (
                              <FormHelperText
                                sx={{ color: "#C52A1A", fontSize: "12px" }}
                              >{`${errors?.claim_raised_by_estimate_time_impact}`}</FormHelperText>
                            )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Claim Raised to Estimate Time Impact"
                            name="claim_raised_to_estimate_time_impact"
                            fullWidth
                            value={values?.claim_raised_to_estimate_time_impact}
                            onChange={handleChange}
                            onBlur={() =>
                              setTouched({
                                ...touched,
                                claim_raised_to_estimate_time_impact: true,
                              })
                            }
                            variant="filled"
                          />
                          {touched?.claim_raised_to_estimate_time_impact &&
                            errors?.claim_raised_to_estimate_time_impact && (
                              <FormHelperText
                                sx={{ color: "#C52A1A", fontSize: "12px" }}
                              >{`${errors?.claim_raised_to_estimate_time_impact}`}</FormHelperText>
                            )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Approved Time Impact"
                            name="approved_time_impact"
                            fullWidth
                            value={values?.approved_time_impact}
                            onChange={handleChange}
                            onBlur={() =>
                              setTouched({
                                ...touched,
                                approved_time_impact: true,
                              })
                            }
                            variant="filled"
                          />
                          {touched?.approved_time_impact &&
                            errors?.approved_time_impact && (
                              <FormHelperText
                                sx={{ color: "#C52A1A", fontSize: "12px" }}
                              >{`${errors?.approved_time_impact}`}</FormHelperText>
                            )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              label="Actual Date of Closure"
                              value={
                                values?.actual_date_of_closure
                                  ? dayjs(values.actual_date_of_closure)
                                  : null
                              }
                              format="DD-MM-YYYY"
                              onChange={(newValue) => {
                                handleChange({
                                  target: {
                                    name: "actual_date_of_closure",
                                    value: newValue ? newValue : "",
                                  },
                                });
                              }}
                              slots={{
                                openPickerIcon: CustomCalendarIcon,
                              }}
                              onBlur={() =>
                                setTouched({
                                  ...touched,
                                  actual_date_of_closure: true,
                                })
                              }
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  variant: "filled",
                                  InputLabelProps: {
                                    style: { fontSize: 16, fontWeight: 400 },
                                  },
                                  inputProps: {
                                    style: { height: "20px" },
                                  },
                                  placeholder: "dd/mm/yyyy",
                                  sx: {
                                    input: {
                                      "&::placeholder": {
                                        fontSize: 16,
                                        fontWeight: 400,
                                      },
                                    },
                                    "& .MuiFormLabel-asterisk": {
                                      color: "red",
                                      fontSize: 20,
                                    },
                                  },
                                  onKeyDown: (e) => e.preventDefault(),
                                },
                              }}
                            />
                            {touched?.actual_date_of_closure &&
                              errors?.actual_date_of_closure && (
                                <FormHelperText
                                  sx={{ color: "#C52A1A", fontSize: "12px" }}
                                >{`${errors?.actual_date_of_closure}`}</FormHelperText>
                              )}
                          </LocalizationProvider>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <Autocomplete
                            options={Statuses}
                            getOptionLabel={(option) => option?.label}
                            value={
                              Statuses.find(
                                (option) => option.label === values?.status
                              ) || null
                            }
                            onChange={(_, newValue) =>
                              setFieldValue(
                                "status",
                                newValue ? newValue.label : ""
                              )
                            }
                            onBlur={() =>
                              setTouched({ ...touched, status: true })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Status"
                                name="status"
                                // error={touched?.package && Boolean(errors?.package)}
                                // helperText={touched?.package && errors?.package}
                                slotProps={{ inputLabel: { shrink: true } }}
                                variant="filled"
                              />
                            )}
                            ListboxProps={{
                              sx: { fontSize: "13px" },
                            }}
                          />
                          {touched?.status && errors?.status && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.status}`}</FormHelperText>
                          )}
                        </Grid>

                        <Grid item xs={12}>
                          <TextField
                            label="Description of Claim"
                            name="description_of_claim"
                            fullWidth
                            multiline
                            value={values?.description_of_claim}
                            onChange={handleChange}
                            onBlur={() =>
                              setTouched({
                                ...touched,
                                description_of_claim: true,
                              })
                            }
                            variant="filled"
                          />
                          {touched?.description_of_claim &&
                            errors?.description_of_claim && (
                              <FormHelperText
                                sx={{ color: "#C52A1A", fontSize: "12px" }}
                              >{`${errors?.description_of_claim}`}</FormHelperText>
                            )}
                        </Grid>
                        <Grid item xs={12}>
                          {files.length > 0 && (
                            <>
                              <Typography
                                variant="h6"
                                gutterBottom
                                style={{
                                  color: "#474747",
                                  fontWeight: "400",
                                  fontSize: "16px",
                                }}
                              >
                                Uploaded Files
                              </Typography>

                              <List dense>
                                {files.map((file, index) => (
                                  <ListItem
                                    key={index}
                                    sx={{
                                      padding: 0,
                                    }}
                                    secondaryAction={
                                      <IconButton
                                        edge="end"
                                        aria-label="delete"
                                        onClick={() =>
                                          handleRemoveFile(file.name)
                                        }
                                      >
                                        <RxCross2 />
                                      </IconButton>
                                    }
                                  >
                                    <ListItemAvatar>
                                      <Avatar sx={{ background: "none" }}>
                                        <FaRegFileLines
                                          fontSize="inherit"
                                          style={{ color: "#474747" }}
                                        />
                                      </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText primary={`${file.name}`} />
                                  </ListItem>
                                ))}
                              </List>
                            </>
                          )}
                        </Grid>

                        <Grid item xs={12}>
                          <DragAndDropUpload
                            onDrop={handleDrop}
                            multi={true}
                            fileType="both"
                          />
                        </Grid>

                        <Grid item xs={12}>
                          {/* <Button
                          onClick={cancelIssue}
                          variant="outlined"
                          sx={{
                            color: `${newtheme?.customSettings?.themeColor}`,
                            border: `1px solid ${newtheme?.customSettings?.themeColor}`,
                            padding: "6px 20px",
                            fontWeight: "500",
                            textTransform: "none",
                            float: "right",
                            fontSize: "16px",
                          }}
                        >
                          Cancel
                        </Button> */}
                          <Button
                            type="submit"
                            loading={isLoading}
                            variant="contained"
                            sx={{
                              marginRight: "20px",
                              backgroundColor: `${newtheme?.customSettings?.themeColor}`,
                              color: "#FFF",
                              padding: "6px 20px",
                              fontWeight: "500",
                              textTransform: "none",
                              float: "right",
                              fontSize: "16px",
                            }}
                          >
                            Save
                          </Button>
                        </Grid>
                      </Grid>
                    </form>
                  );
                }}
              </Formik>
            </Box>
          </ThemeProvider>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
